import * as React from "react";
import {useEffect} from "react";
import {withNavigation} from "../navigation/navigation";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {Box, Button, Stack, Typography, Paper, Breadcrumbs} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import {Tabs} from '@mui/base/Tabs';
import {TabsList} from '@mui/base/TabsList';
import {TabPanel} from '@mui/base/TabPanel';
import TabBase from "../tab/tab";
import {
    Apartment as ApartmentIcon,
    Article as ArticleIcon, Celebration as CelebrationIcon, Group as GroupIcon,
    Highlight as HighlightIcon,
    List as ListIcon, QueryStats as QueryStatsIcon,
    Soap as SoapIcon
} from "@mui/icons-material";
import {useState} from "react";
import Select from 'react-select';
import {useSubmit} from "./hooks/useSubmit";
import Result from "../search/Result";
import Container from "@mui/material/Container";
import ExpandlessPlaceholder from "../placeholder/ExpandlessPlacehoder";
import ProductResult from "./ProductResult";
import {Item} from "./queries/Item";
import {useNavigate} from "react-router-dom";
import {useUserInfo} from "../userInfo/hooks/useUserInfo";
import {withServiceListContext} from "../service/state/serviceContext";

const ProductSearch = ({setShowNav}) => {
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();
    const { getCustomerId } = useSubmit();

    const [disableSeeAll, setDisableSeeAll] = useState(true);
    const [disableEstablishment, setDisableEstablishment] = useState(true);
    const [disableAdvice, setDisableAdvice] = useState(true);
    const [disableService, setDisableService] = useState(true);
    const [disableProduct, setDisableProduct] = useState(true);
    const [productList, setProductList] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [tabValue, setTabValue] = useState(-1);
    const {searchProduct} = useSubmit();
    const [isLoading, setIsLoading] = useState(true);
    const [publicFilterValue, setPublicFilterValue] = useState('');
    const [categoryFilterValue, setCategoryFilterValue] = useState('');
    const [typeFilterValue, setTypeFilterValue] = useState('');

    const [publicFilterOptions, setPublicFilterOptions] = useState([]);
    const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
    const [typeFilterOptions, setTypeFilterOptions] = useState([]);
    const [idPublic, setIdPublic] = useState('');
    const [idType, setIdType] = useState('');
    const navigate = useNavigate();
    const {profil} = useUserInfo();
    const [idCustomer, setIdCustomer] = useState('');

    useEffect(() => {
        Item.getProductFeatureByName('Public cible').then((resp) => {
            setIdPublic(resp.id);
            Item.getFeaturesValues(resp.id).then((values) => {
                console.log('Public', values);
                setPublicFilterOptions(values.map((item) => {
                    return {value: item.id, label: item.value}
                }));
            });
        })
        Item.getProductFeatureByName('Type de produit et service').then((resp) => {
            setIdType(resp.id);
            Item.getFeaturesValues(resp.id).then((values) => {
                console.log('Type', values);
                setTypeFilterOptions(values.map((item) => {
                    return {value: item.id, label: item.value}
                }));
            });
        });
        Item.getCategories().then((categories) => {
            console.log('Cat', categories);
            setCategoryFilterOptions(
                categories
                    .filter(item => item.name !== 'Racine' && item.name !== 'Accueil')
                    .map(item => ({ value: item.id, label: item.name }))
            );
        });

    }, []);

    useEffect(async () => {
        if (profil) {
            const customerId = await getCustomerId(profil);
            setIdCustomer(customerId);
            searchProduct(searchValue).then(resp => {
                console.log('resp', resp);
                setIsLoading(false);
                setProductList(resp);
                if (resp.length > 0 ) {
                    console.log('sdfqd')
                    setTabValue(0);
                }
            });
        }
    }, [profil]);

    const resetFilters = () => {
        setProductList([]);
        setDisableSeeAll(true);
        setDisableEstablishment(true);
        setDisableAdvice(true);
        setDisableService(true);
        setDisableProduct(true);
    }

    const [selectedOption, setSelectedOption] = useState(null);
    const handleChange = (selected) => {
        setSelectedOption(selected);
    }

    const breadcrumbs = [
        <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
        </Typography>,
        <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
            Produits et services
        </Typography>,
    ];


    useEffect(() => {
        setShowNav(false);
    }, []);

    return (
        <Stack style={{marginTop : '15px'}} width={'100%'}>
            <Breadcrumbs
                separator="›"
                aria-label="navigation"
                style={{color: mode.settings.textColor3, marginBottom: '15px'}}>
                {breadcrumbs}
            </Breadcrumbs>
            <Stack width={'100%'} alignItems={'center'} spacing={3}>

                <Stack alignItems={'center'} width={'100%'}>
                    <Paper
                        style={{
                            backgroundColor: mode.settings.cardBackgroundColor,
                            width: 'inherit',
                            maxWidth : '1000px',
                            padding : '10px'
                        }}
                    >
                        <Stack alignItems={'center'} spacing={1.5}>
                            <Stack >
                                <Stack direction={'row'}>
                                    <Typography variant={'subtitle1'} color={mode.settings.textColor3}>Je recherche, </Typography>
                                    <Typography variant={'subtitle1'} color={mode.settings.textColor2}> &nbsp; par filtrage</Typography>
                                </Stack>
                            </Stack>
                            <Stack direction={'row'} width={'100%'} justifyContent={'space-around'} flexWrap={'wrap'} gap={'10px'}>
                                <Select
                                    value={publicFilterValue}
                                    onChange={setPublicFilterValue}
                                    options={publicFilterOptions}
                                    placeholder={'Profil de la personne concernée'}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            backgroundColor : mode.settings.inputBackgroundColor,
                                            width : '296px',
                                            height : '47px',
                                            fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                        }),
                                        placeholder: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            }
                                        },
                                        singleValue: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                            return {
                                                ...styles,
                                                color: mode.settings.textColor3,
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            };
                                        },
                                        option: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic',
                                                backgroundColor : mode.settings.inputBackgroundColor,
                                            }
                                        },
                                    }}
                                />
                                <Select
                                    value={typeFilterValue}
                                    onChange={setTypeFilterValue}
                                    options={typeFilterOptions}
                                    placeholder={'Type de produit et service'}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            backgroundColor : mode.settings.inputBackgroundColor,
                                            width : '296px',
                                            height : '47px',
                                            fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                        }),
                                        placeholder: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            }
                                        },
                                        singleValue: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                            return {
                                                ...styles,
                                                color: mode.settings.textColor3,
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            };
                                        },
                                        option: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic',
                                                backgroundColor : mode.settings.inputBackgroundColor,
                                            }
                                        },

                                    }}
                                />
                                <Select
                                    value={categoryFilterValue}
                                    onChange={setCategoryFilterValue}
                                    options={categoryFilterOptions}
                                    placeholder={'Type de prestation'}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            backgroundColor : mode.settings.inputBackgroundColor,
                                            width : '296px',
                                            height : '47px',
                                            fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                        }),
                                        placeholder: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            }
                                        },
                                        singleValue: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                            return {
                                                ...styles,
                                                color: mode.settings.textColor3,
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                            };
                                        },
                                        option: (defaultStyles) => {
                                            return {
                                                ...defaultStyles,
                                                color: mode.settings.textColor3,
                                                fontSize: '14px',
                                                fontFamily: police.normalMode ? 'Roboto' : 'dyslexic',
                                                backgroundColor : mode.settings.inputBackgroundColor,
                                            }
                                        },
                                    }}
                                />
                            </Stack>
                            <Stack  direction={'row'} width={'100%'}
                                    justifyContent={'center'}
                                    flexWrap={'wrap'}
                                    gap={2}
                            >
                                <Button
                                    sx={{
                                        width: '230px',
                                        height : '39px',
                                        backgroundColor : mode.settings.color15,
                                        color : mode.settings.textColor,
                                        borderRadius : '5px'
                                    }}
                                    onClick={() => {
                                        resetFilters();
                                        setPublicFilterValue('');
                                        setCategoryFilterValue('');
                                        setTypeFilterValue('');
                                    }}
                                >
                                    <Typography variant={'subtitle8'}>Annuler mes filtres</Typography>
                                </Button>
                                <Button
                                    sx={{
                                        width: '230px',
                                        height : '39px'
                                    }}
                                    className="btn-gradient"
                                    variant="contained"
                                    onClick={async () => {
                                        resetFilters();
                                        setIsLoading(true);
                                        Item.getFilteredProducts(categoryFilterValue.value, idPublic, publicFilterValue.value, idType, typeFilterValue.value, idCustomer, profil)
                                            .then(resp => {
                                                console.log('resp', resp);
                                                setIsLoading(false);
                                                setProductList(resp);
                                                console.log('sdfq', resp.length)
                                                if (resp.length > 0 ) {
                                                    console.log('sdfqd')
                                                    setTabValue(0);
                                                }
                                            });
                                    }}
                                >
                                    <Typography variant={'subtitle8'}>Appliquer mes filtres</Typography>
                                </Button>
                            </Stack>
                            <Stack >
                                <Stack direction={'row'}>
                                    <Typography variant={'subtitle1'} color={mode.settings.textColor3}>Je recherche, </Typography>
                                    <Typography variant={'subtitle1'} color={mode.settings.textColor2}> &nbsp; par mots clés</Typography>
                                </Stack>
                            </Stack>
                            <form id={"searchInputContainer"} style={{width : '100%', justifyContent: 'center'}}>
                                <input
                                    aria-label={"Champ de recherche"}
                                    title={'contenu'}
                                    id={'searchInput'}
                                    name={'searchInput'}
                                    style={{
                                        maxWidth: 425,
                                        width: '80%',
                                        backgroundColor: mode.settings.inputBackgroundColor,
                                        color: mode.settings.textColor2,
                                        paddingLeft: 15,
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                    }}

                                    onChange={event => setSearchValue(event.target.value)}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            resetFilters();
                                            setPublicFilterValue('');
                                            setCategoryFilterValue('');
                                            setTypeFilterValue('');
                                            setIsLoading(true);
                                            searchProduct(searchValue).then(resp => {
                                                console.log('resp', resp);
                                                setIsLoading(false);
                                                setProductList(resp);
                                                if (resp.length > 0 ) {
                                                    console.log('sdfqd')
                                                    setTabValue(0);
                                                }
                                            });
                                        }
                                    }}
                                    placeholder="Faites votre recherche"
                                />
                                <Button
                                    id = "buttonSearch"
                                    endIcon={<SearchIcon role={'img'} aria-label={"search-button"} size={20}/>}
                                    onClick={async () => {
                                        resetFilters();
                                        setPublicFilterValue('');
                                        setCategoryFilterValue('');
                                        setTypeFilterValue('');
                                        setIsLoading(true);
                                        searchProduct(searchValue).then(resp => {
                                            console.log('resp', resp);
                                            setIsLoading(false);
                                            setProductList(resp);
                                            if (resp.length > 0 ) {
                                                console.log('sdfqd')
                                                setTabValue(0);
                                            }
                                        });
                                    }}
                                >
                                </Button>
                            </form>
                        </Stack>
                    </Paper>
                </Stack>
                <Stack sx={{maxWidth : '1020px', width : '100%'}} alignItems={'center'} direction={'row'}>
                    <Tabs defaultValue={0} style={{width : '100%'}}

                    >
                        <TabsList style={{display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10}}>
                            <TabBase value={0} disabled={disableSeeAll} style={{width :'190px'}}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1}
                                       onClick={() => {
                                           if (!disableSeeAll) {
                                               setTabValue(0)
                                           }

                                       }}
                                       sx={{
                                           color: tabValue === 0 ? mode.settings.textColor11 : disableSeeAll ? `black` : `white`,
                                           width: '100%',
                                           height: '100%'
                                       }}
                                >
                                    <SearchIcon role="img" aria-label="Voir tous les résultats"/>
                                    <Typography variant={'subtitle3'}>Voir tout</Typography>
                                </Stack>
                            </TabBase>
                            <TabBase value={1} disabled={disableService} style={{width :'190px'}}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1}
                                       onClick={() => {
                                           if (!disableService) {
                                               setTabValue(1)
                                           }

                                       }}
                                       sx={{
                                           color: tabValue === 1 ? mode.settings.textColor11 : disableService ? `black` : `white`,
                                           width: '100%',
                                           height: '100%'
                                       }}
                                >
                                    <img style={{height: '25px', width: '30px', marginBottom: '5px'}}
                                         src={tabValue === 1 ? `/assets/icon/service-blue.png` : disableService ? `/assets/icon/service-gray.png` : `/assets/icon/service-white.png`}
                                         alt={'Voir les résultats de catégorie Services'}
                                    />
                                    <Typography variant={'subtitle3'}>Services</Typography>
                                </Stack>
                            </TabBase>
                            <TabBase value={2} disabled={disableProduct} style={{width :'190px'}}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1}
                                       onClick={() => {
                                           if (!disableProduct) {
                                               setTabValue(2)
                                           }

                                       }}
                                       sx={{
                                           color: tabValue === 2 ? mode.settings.textColor11 : disableProduct ? `black` : `white`,
                                           width: '100%',
                                           height: '100%'
                                       }}
                                >
                                    <img style={{height: '25px', width: '30px'}}
                                         src={tabValue === 2 ? `/assets/icon/product-blue.png` : disableProduct ?  `/assets/icon/product-gray.png` : `/assets/icon/product-white.png`}
                                         alt={'Voir les résultats de catégorie Produits'}
                                    />
                                    <Typography variant={'subtitle3'}>Produits</Typography>
                                </Stack>
                            </TabBase>
                            <TabBase value={3} disabled={disableAdvice} style={{width: '190px'}}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1}
                                       onClick={() => {
                                           if (!disableAdvice) {
                                               setTabValue(3)
                                           }
                                       }}
                                       sx={{
                                           color: tabValue === 3 ? mode.settings.textColor11 : disableAdvice ? `black` : `white`,
                                           width: '100%',
                                           height: '100%'
                                       }}
                                >
                                    <img style={{height: '25px', width: '30px', marginBottom: '3px'}}
                                         src={tabValue === 3 ? `/assets/icon/advice-blue.png` : disableAdvice ? `/assets/icon/conseil-gray.png` : `/assets/icon/conseil-white.png`}
                                         alt={'Voir les résultats de catégorie Conseils'}
                                    />
                                    <Typography variant={'subtitle3'}>Conseils</Typography>
                                </Stack>
                            </TabBase>
                            {/*<TabBase value={5} disabled={disableEstablishment} onClick={() => {*/}
                            {/*    setTabValue(5)*/}
                            {/*}} style={{width :'190px'}}>*/}
                            {/*    <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1}>*/}
                            {/*        <ApartmentIcon role="img"*/}
                            {/*                       aria-label="Voir les résultats de catégorie Etablissements"></ApartmentIcon>*/}
                            {/*        <Typography variant={'subtitle3'}>Etablissements</Typography>*/}
                            {/*    </Stack>*/}
                            {/*</TabBase>*/}
                        </TabsList>
                        { !isLoading ?
                            <div>
                                <TabPanel value={0}>
                                    <ProductResult searchResponse={productList}
                                                   allowedResponse={['conseil', 'service', 'produit']}
                                                   setDisableSeeAll={setDisableSeeAll}
                                                   setDisableService={setDisableService}
                                                   setDisableAdvice={setDisableAdvice}
                                                   setDisableProduct={setDisableProduct}
                                                   setTabValue={setTabValue}
                                                   isLoading={isLoading}
                                    >
                                    </ProductResult>
                                </TabPanel>
                                <TabPanel value={1}>
                                    <ProductResult searchResponse={productList}
                                                   allowedResponse={['service']}
                                                   setDisableSeeAll={setDisableSeeAll}
                                                   setDisableService={setDisableService}
                                                   setDisableAdvice={setDisableAdvice}
                                                   setDisableProduct={setDisableProduct}
                                                   setTabValue={setTabValue}
                                                   isLoading={isLoading}
                                    >
                                    </ProductResult>
                                </TabPanel>
                                <TabPanel value={2}>
                                    <ProductResult searchResponse={productList}
                                                   allowedResponse={['produit']}
                                                   setDisableSeeAll={setDisableSeeAll}
                                                   setDisableService={setDisableService}
                                                   setDisableAdvice={setDisableAdvice}
                                                   setDisableProduct={setDisableProduct}
                                                   setTabValue={setTabValue}
                                                   isLoading={isLoading}
                                    >
                                    </ProductResult>
                                </TabPanel>
                                <TabPanel value={3}>
                                    <ProductResult searchResponse={productList}
                                                   allowedResponse={['conseil']}
                                                   setDisableSeeAll={setDisableSeeAll}
                                                   setDisableService={setDisableService}
                                                   setDisableAdvice={setDisableAdvice}
                                                   setDisableProduct={setDisableProduct}
                                                   setTabValue={setTabValue}
                                                   isLoading={isLoading}
                                    >
                                    </ProductResult>
                                </TabPanel>
                            </div>
                            : <Container maxWidth={"lg"}><ExpandlessPlaceholder/></Container>  }
                    </Tabs>
                </Stack>
            </Stack>

        </Stack>
            )
}

export default withServiceListContext(withNavigation(ProductSearch));
